import React from "react";
import { Text } from "tea-component";

import "@gp/assets/css/components/nodata.css";

interface initProps {
  className?: string;
  text?: string | any;
  height?: number | string;
  width?: number | string;
  constomStyle?: React.CSSProperties;
}
export default function index(props: initProps) {
  const {
    className = '',
    text = "No Data",
    height = "100%",
    width = "100%",
    constomStyle = {},
  } = props;

  return (
    <div style={Object.assign({ height, width }, constomStyle)} className={`dbg-assets-no-data dbg-common-dbg-assets-no-data ${className}`}>
      <Text theme="label" align="center" verticalAlign="middle">{text}</Text>
    </div>
  );
}
